// extracted by mini-css-extract-plugin
export default {"card":"l4-z"};